export const registerServiceWorker = () => {
  if ("serviceWorker" in navigator) {
    let isReloadingForUpdate = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (isReloadingForUpdate) {
        return;
      }

      isReloadingForUpdate = true;
      window.location.reload();
    });

    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/sw.js", { scope: "/", updateViaCache: "none" })
        .then((registration) => registration.update())
        .catch(() => {
          // The app remains fully usable without offline caching.
        });
    });
  }
};
